module.exports = __webpack_public_path__ + "static/media/student-end-season-next.ff144590.png";